module.exports = __webpack_public_path__ + "Ubisoft-plus-crew-2-gold-edition_tablet.png";